import {
  FETCH_CMS_SUPPORT,
  FETCH_CMS_SUPPORT_SUCCESS,
  FETCH_CMS_SUPPORT_FAILURE,
} from '../actions/cmsSupport';

const INITIAL_STATE = {
  loading: false,
  requested: false,
  cacheValid: false,
  data: null,
  error: null,
};

export default function cmsSupport(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_CMS_SUPPORT:
      return {
        ...state,
        loading: true,
        requested: true,
        error: null,
      };
    case FETCH_CMS_SUPPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        cacheValid: true,
        data: action.payload,
        error: null,
      };
    case FETCH_CMS_SUPPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
